<div [ngStyle]="{ display: figuresRef.children.length ? 'block' : 'none' }" class="figures-wrapper">
  <div class="figures" #figuresRef>
    <ng-content
      select="ms-speed-reading-result-figure, [ms-speed-reading-result-figure], ms-speed-reading-result-questions, [ms-speed-reading-result-questions]"
    ></ng-content>
  </div>
</div>
